import axios from 'axios';
import RelatedGallery from "./RelatedGellery";

class RelatedProductPopup {
  init() {
    this.triggerElementClass = 'js-related-product-popup';
    this.popupContainerClass = 'js-popup';
    this.container = document.querySelector('.product__list');

    if(this.container) {
      this.eventListeners()
    }
  }

  eventListeners() {
    this.container.addEventListener('click', this.fetchPopup.bind(this))
    document.addEventListener('keydown', this.fetchEsc.bind(this))
    document.addEventListener('click', this.fetchBodyClick)
  }

  fetchEsc(event) {
    let keyCode = event.keyCode;
    if (keyCode === 27) {
      this.closePopup();
    }
  }

  closePopup() {
    let popup = document.querySelector('.' + this.popupContainerClass);
    if (popup) {
      popup.remove();
    }
  }

  fetchPopup(event) {

    if(!event.target.classList.contains(this.triggerElementClass)) return false;
    event.preventDefault();

    this.getProduct(event.target)
  }

  getProduct(element) {
    let params = new FormData();
    let _this = this;
    console.log('+++ Related Product +++');
    console.log('Params: ' + params);
    for (var values of params.values()) {
      console.log(values);
    }
    console.log('+++ End of first params +++');

    params.append('action', 'get_product');
    params.append('product_id', element.dataset.productId);
    element.classList.add('loading');
    element.insertAdjacentHTML('beforeend', '<div class="loader"></div>');

    axios.post(WP_DATA.ajax_url, params)
      .then((response) => {
        console.log(response.status);
        console.log(response.data);
        if (response.status === 200) {
          element.classList.remove('loading');
          element.querySelector('.loader').remove();
          document.querySelector('body').insertAdjacentHTML('beforeend', response.data);
         // const relatedGallery = new RelatedGallery();
        //   relatedGallery.init({
        //     'optionsThumbs':  {perPage: 3, fixedHeight: 140},
        //     'optionsMain': {fixedHeight: 515}
        //   });

            const relatedGallery = new RelatedGallery();
            relatedGallery.init();
        }
        //console.log('Const Gallery: ' + relatedGallery);

        console.log('+++ Start of last params +++');
        for (var value of params.values()) {
          console.log(value);
        }
        console.log('+++ End of last params +++');

      })
      .catch((error) => console.log(error))
  }
}

export default RelatedProductPopup;
